/* eslint-disable */
/**
 * Mobile navigation menu
 */
export class SideMenu {
  constructor() {
    this.$menuBtn = $('#menuBtn');
    this.$body = $('body');
    this.$close = $('#closeSidebar');
    this.$closeChildren = $('#closeSidebarChildren');
    this.$overlay = $('#overlay');
    this.$topLevel = $('.page-nav__top-level');
    this.$subLevel = $('.page-nav__sub-level');
    this.$header = $('.side-bar__header');
    this.$headerTitle = $('#sidebarHeaderTitle');
    this.$parent = $('[data-component="sidebar__parent"]');
    this.schoolButton = $('.school-btn-mobile');
    this.$mobileItem = $('.mobile-menu-item');

    // Bind events
    this.$menuBtn.on('click', e => this.open(e));
    this.$close.on('click', () => this.close());
    this.$overlay.on('click', () => this.close());

    this.$parent.on('click', e => this.openChild(e));
    this.$closeChildren.on('click', e => this.closeChild(e));

    this.$mobileItem.on('click', e => this.toggleSubmenu(e));
  }

  open(e) {
    e.preventDefault();
    this.$body.addClass('sidebarOpen');
    this.$menuBtn.removeClass('visible-xs').removeClass('visible-sm').removeClass('visible-md').hide();
    this.$close.css('display', 'flex');
    //this.$overlay.fadeIn(100);
  }

  close() {
    this.$body.removeClass('sidebarOpen');
    this.$overlay.fadeOut(200);
    this.$menuBtn.removeClass('animate');
    this.$menuBtn.addClass('visible-xs').addClass('visible-sm').addClass('visible-md');
    this.$close.hide();
  }

  openChild(e) {
    const $self = $(e.currentTarget);
    const $children = $self.next('[data-component="sidebar__children"]');
    const title = $self.html();

    if (e && $children.length) {
      e.preventDefault();
      this.$subLevel.html($children.clone());
      this.$headerTitle.html(title);
      this.showChildren(true);
    } else {
      this.close();
    }
  }

  closeChild(e) {
    e.preventDefault();
    this.$headerTitle.html('');
    this.$subLevel.html('');
    this.showChildren(false);
  }

  showChildren(show) {
    this.$topLevel[show?'addClass':'removeClass']('page-nav__top-level--inactive');
    this.$subLevel[show?'addClass':'removeClass']('page-nav__sub-level--active');

    this.$close[show?'hide':'show']();
    this.$closeChildren[show?'show':'hide']();

    this.schoolButton[show?'addClass':'removeClass']('school-btn-mobile--active');

    this.$header[show?'addClass':'removeClass']('side-bar__header--active');
  }

  toggleSubmenu(e) {
    const $self = $(e.currentTarget);
    $self.find('div').first().slideToggle();
    $self.find('h3').first().toggleClass('mobile-menu-item-active');
  }

}
